module.exports = __webpack_public_path__ + "img/total.8bd8023.jpg";